/*
  Footer menus: on phones, menu columns with a heading collapse behind a toggle button.
  On larger screens the lists are always shown (the toggle is not displayed).
  Without JavaScript every list stays open.
*/
(() => {
  const mq = window.matchMedia('(max-width: 749px)');
  const toggles = () => document.querySelectorAll('[data-g-foot-toggle]');
  const listFor = (button) => document.getElementById(button.getAttribute('aria-controls'));

  function setOpen(button, open) {
    button.setAttribute('aria-expanded', String(open));
    const list = listFor(button);
    if (list) list.hidden = !open;
  }

  function apply() {
    toggles().forEach((button) => setOpen(button, !mq.matches));
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-g-foot-toggle]');
    if (!button) return;
    setOpen(button, button.getAttribute('aria-expanded') !== 'true');
  });
  mq.addEventListener('change', apply);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();
  document.addEventListener('shopify:section:load', apply);
})();
